import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';
import { isUseTenantIdInQuery } from 'common/helpers/featureFlags';

export const getForWeb = () => {
  const axiosHeaders = publicAxiosHeaderV2();
  const { headers } = axiosHeaders;

  if (isUseTenantIdInQuery(headers.tenantId)) {
    return axios.get(
      `${getV2RootUrl()}/setting/for-web?version=V2&tenantId=${headers.tenantId}`
    );
  }
  return axios.get(
    `${getV2RootUrl()}/setting/for-web?version=V2`,
    publicAxiosHeaderV2()
  );
};
